export const ADD_PAGE_ALERT = 'ADD_PAGE_ALERT';
export const CLEAR_PAGE_ALERT = 'CLEAR_PAGE_ALERT';

export const addPageAlert = (text) => ({
    type: ADD_PAGE_ALERT,
    text: text
});

export const clearPageAlert = () => ({
    type: CLEAR_PAGE_ALERT
});